export default function CollectionOpening({ count }: { count: number }) {
  return (
    <section data-nav-dark className="bg-[#171515] text-[#F5F1EB] pt-32 md:pt-44 pb-14 md:pb-20 mb-12 md:mb-16" aria-labelledby="collection-heading">
      <div className="fold-shell">
      <div className="flex items-baseline justify-between gap-6 border-b border-[rgba(245,241,235,0.14)] pb-5">
        <p className="fold-label text-[rgba(245,241,235,0.6)]">FOLD. — Made in Layers</p>
        <p className="fold-label text-[rgba(245,241,235,0.6)] tabular-nums">{String(count).padStart(2, '0')} pieces</p>
      </div>
      <div className="mt-10 md:mt-14 grid grid-cols-1 lg:grid-cols-[minmax(0,7fr)_minmax(0,3fr)] gap-y-8 gap-x-12 xl:gap-x-16 lg:items-end">
        <h1 id="collection-heading" className="min-w-0 fold-serif uppercase leading-[0.86] tracking-[-0.035em] text-[15vw] lg:text-[10.4vw] xl:text-[9.6rem]">
          The<br />
          <span className="italic">Collection.</span>
        </h1>
        <div className="min-w-0 max-w-[420px] lg:max-w-none lg:pb-3 lg:border-l lg:border-[rgba(245,241,235,0.2)] lg:pl-8">
          <p className="fold-serif text-xl md:text-[22px] leading-snug">A considered selection, baked in small batches.</p>
          <p className="mt-4 text-[15px] leading-relaxed text-[rgba(245,241,235,0.65)]">
            Every piece is made by hand in one room, the same morning you collect it.
          </p>
        </div>
      </div>
      </div>
    </section>
  );
}